import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Column, ColumnProps } from 'primereact/column'
import { DataTable, DataTableExpandedRows, DataTableProps } from 'primereact/datatable'
import React, { useState } from 'react'
import classes from './AddAttachmentsRPDropzoneGrid.module.scss'
import { faCloudUpload } from '@fortawesome/free-solid-svg-icons'
import { DropzoneState } from 'react-dropzone'

interface AddAttachmentsRPDropzoneGridProps {
  dtProps?: DataTableProps
  columns?: ColumnProps[]
  dropzoneState: DropzoneState
  gridContainerClassName?: string
}

const AddAttachmentsRPDropzoneGrid = (props: AddAttachmentsRPDropzoneGridProps) => {
  const [expandedRows, setExpandedRows] = useState<any[] | DataTableExpandedRows>([])

  const InlineRenderEmptyMessage = () => {
    return (
      <div className={classes['add-attachments-rp-dropzone-grid-empty-container']}>
        <FontAwesomeIcon icon={faCloudUpload} size="lg" />
        <div className={classes['add-attachments-rp-dropzone-grid-empty-container-label']}>
          Drag and Drop Files here
        </div>
      </div>
    )
  }

  return (
    <div className={`${props.gridContainerClassName}`}>
      <DataTable
        dataKey="id"
        className={classes['add-attachments-rp-dropzone-grid']}
        tableClassName={classes['add-attachments-rp-main-table']}
        size="small"
        columnResizeMode="expand"
        responsiveLayout="scroll"
        scrollable
        emptyMessage={<InlineRenderEmptyMessage />}
        expandedRows={expandedRows}
        onRowToggle={event => setExpandedRows(event.data)}
        {...props.dtProps}
      >
        {props.dtProps?.rowExpansionTemplate && (
          <Column
            expander
            bodyClassName={`${classes['add-attachments-rp-dropzone-grid-expand-icon']}`}
            headerStyle={{ flex: '0', paddingLeft: '1.4rem' }}
          />
        )}
        {props.dtProps?.selectionMode && (
          <Column
            selectionMode="multiple"
            style={{ maxWidth: '30px', flex: 'none' }}
            headerStyle={{ width: '30px' }}
          ></Column>
        )}

        {props.columns?.map((column, index) => {
          return <Column key={`${column.field}-${index}`} {...column} />
        })}
      </DataTable>
    </div>
  )
}

export default AddAttachmentsRPDropzoneGrid
